import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    blocks: {
      width: '470px',
    },
    btn: {
      fontWeight: 'bold',
      color: '#2B3990',
      padding: 0,
      fontSize: '14px',
    },
    rectangle: {
      padding: '9px 14px',
      borderRadius: '4px',
      border: '1px dashed  #b0bec5',

    },
    hl: {
      position: 'absolute',
      width: '3%',
      marginTop: '18px',
      left: 11,
      borderTop: '2px dashed #b0bec5',
    },
    vl: {
      borderRight: '2px dashed #b0bec5',
      height: '35px',
      position: 'absolute',
      left: '11px',
      marginTop: '-16px',
    },
  }));